import * as React from "react";
import NextImage from "next/image";
import { Text, Heading } from "@chakra-ui/react";

import CustomLink from "components/Chakra/CustomLink";
import ResponsiveStack from "components/Chakra/ResponsiveStack";

interface IProps {
  imageUrl?: string;
  name?: string;
  title?: string;
  email?: string;
  phone?: string;
  head?: string;
}

const ContactBadge: React.FunctionComponent<IProps> = ({
  imageUrl,
  name,
  title,
  email,
  phone,
  head,
}) => (
  <ResponsiveStack direction="row" spacing="15px" alignItems="center">
    {imageUrl && (
      <NextImage
        src={imageUrl}
        alt=""
        height="72"
        width="72"
        style={{ borderRadius: "full" }}
      />
    )}
    <ResponsiveStack spacing="3px" w="200px">
      {head && <Heading as="h3">{head}</Heading>}
      {name && (
        <Text fontWeight="bold" textAlign="left">
          {name}
        </Text>
      )}
      {title && <Text textAlign="left">{title}</Text>}
      {email && (
        <Text textAlign="left">
          <CustomLink href={`mailto:${email}`}>{email}</CustomLink>
        </Text>
      )}
      {phone && <Text textAlign="left">{phone}</Text>}
    </ResponsiveStack>
  </ResponsiveStack>
);

export default ContactBadge;
